































































































































































































































import { Component, Vue,Prop, Model, Watch  } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import Pop from './components/pop.vue'
import PopNew from './components/popNew.vue';
import EmbeddedPopup from './components/embeddedPopup.vue'
import EmbeddedPopupNew from './components/embeddedPopupNew.vue'
import Text from './components/text.vue'
import {FormWheelOfFortuneSettingsVO, FormWheelSliceVO, PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import { getCountryPhoneCodeCodeList, getQueryVariable } from "@/services/api";
import EventBus from '@/utils/eventBus';
import { DISABLE_CUSTOM_STEP_TPLID, DISABLE_CUSTOM_STEP_TPLID_NEW, isEnableCustomFormFeatureGray, isOnlyNewUserTemplate } from "@/utils/experiment";
import { copyMiddleToStart, copyStartToMiddle } from "@/utils/copyPageConfig";
import { shortFormAddList } from "@/views/wheelOfFortune/constant/options";
import {
  getFormPageValues,
  getMiddlePageValues,
  getNextAvailableMiddlePageValue,
  isMiddlePage,
  buildMiddlePageValue,
  isCustomStepLimitExcludedForm,
  isShortFormTemplate
} from '../utils/stepPages';

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    "pop-exhibition": Pop,
    "pop-new": PopNew,
    "text-exhibition": Text,
    "embedded-popup": EmbeddedPopup,
    "embedded-popup-new": EmbeddedPopupNew,
  }
})
export default class wheelOfFortunePop extends Vue {

  @Prop(Array)
  pageSettings!:any

  @Prop(Number)
  triggerEventType!:any

  @Prop(String)
  activePageSetting!:string;

  @Prop(Object)
  formData!:TFormSaveDetailRequest<PopSettingsVO>;

  device = 'desktop'
  countryList = []
  subscribeStatus = 'success'
  /** 分步骤步数 */
  step = '1';

  showDeleteDialog = false;
  showDeletePageDialog = false;
  deletePageValue: string | null = null;

  get canAddCover() {
    const hasCover = (this.pageSettings || []).some((item: any) => item.value === 'cover');
    console.log('canAddCover', hasCover, this.formData, this.formData.coverDisplay, this.formData.popWindowWheel);
    return (
      (this.formData.popWindowWheel !== 1 && this.formData.coverDisplay === 1) &&
      !hasCover
    );
  }

  get canAddForm() {
    const formList = getFormPageValues(this.pageSettings || []);
    const buttonAction = this.formData.settings.rules.buttonAction;
    const shortFormOnly = isShortFormTemplate(this.formData, getQueryVariable('templateid') || this.formData?.templateId);
    const customStepLimitExcluded = isCustomStepLimitExcludedForm(this.formData, getQueryVariable('templateid') || this.formData?.templateId);
    // 未命中扩展灰度的店铺，维持老的 2 步上限（start + 1 个 middle）
    const featureMaxPages = isEnableCustomFormFeatureGray() ? 5 : 2;
    const maxPages = this.triggerEventType === 7 || shortFormOnly || customStepLimitExcluded ? 2 : featureMaxPages;
    return buttonAction === 'open' && formList.length < maxPages;
  }

  get enableSubscribeDifferentPage() {
    return this.formData.successPageType === 1;
  }

  get enableOnlyNewUserCustomStep() {
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    return isOnlyNewUserTemplate(templateId);
  }

  get enableCustomStep() {
    if ([3, 5, 6].includes(this.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    if (this.enableOnlyNewUserCustomStep) {
      return !DISABLE_CUSTOM_STEP_TPLID_NEW.includes(templateId);
    }
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  async created(): Promise<void> {
    this.getPhoneCodeCodeList()
    
    // 监听清空订阅状态的事件
    EventBus.$on('clear-subscribe-status', () => {
      this.subscribeStatus = 'success';
    });
  }

  @Watch('activePageSetting', { immediate: true })
  activePageSettingChange(value: string, oldValue: string) {
    console.log('[step][activePageSetting]', {
      value,
      oldValue,
      currentStep: this.step
    });
    if (value === 'start') {
      this.step = '1';
    }
  }

  async getPhoneCodeCodeList(){
    let {data ,status }  = await getCountryPhoneCodeCodeList({},true)
    if (status == 200) {
      this.countryList = data.data
    }
  }

  changeActivePageSetting(val: string, opacity: number){
    if (opacity != 1) {
      return;
    }
    console.log('[step][changeActivePageSetting]', {
      val,
      currentStep: this.step,
      activePageSetting: this.activePageSetting
    });
    if (val === 'start_1') {
      this.$emit('changeActivePageSetting', 'start_1');
      this.step = '2';
    } else {
      if (val === 'start') {
        this.step = '1';
      }
      this.$emit('changeActivePageSetting', val);
    }
  }

  getActiveSliderLeft() {
    return `${this.pageSettings.findIndex((item: any) => item.value === this.activePageSetting) * 122 + 4}px`;
  }

  changeText(e:any){
    this.$emit('changeformData',e)
  }

  nextStep(){
    this.$emit('nextStep')
  }

  backStep() {
    this.$emit('backStep')
  }

  cancel(){
    this.$emit('cancel')
  }

  changeSubscribeStatus() {
    // 订阅状态切换时的处理逻辑
    // subscribeStatus 值会自动更新，通过 prop 传递给 embedded-popup
  }

  @Watch('formData.settings.rules.terminalType')
  terminalTypeChange(val:string){
    if (this.formData.settings.rules.terminalType === 'mobile') {
      this.device = 'phone'
    }else if (this.formData.settings.rules.terminalType === 'pc') {
      this.device = 'desktop'
    }else{
      this.device = 'desktop'
    }
  }

  /** 删除指定页面 */
  handleDeletePage(value: string) {
    this.deletePageValue = value;
    this.showDeletePageDialog = true;
  }

  getFormPageArrays(values: string[]) {
    return values.map((value: string) => {
      const list = (this.formData?.settings as any)?.[value] || [];
      return JSON.parse(JSON.stringify(list));
    });
  }

  rebuildFormPageSettings(formPageArrays: any[]) {
    const settings: any = this.formData?.settings;
    if (!settings) {
      return;
    }

    Object.keys(settings).filter(isMiddlePage).forEach((key: string) => {
      if (settings[key] !== undefined) {
        Vue.delete(settings, key);
      }
    });

    Vue.set(settings, 'start', formPageArrays[0] || []);
    formPageArrays.slice(1).forEach((list: any, index: number) => {
      Vue.set(settings, buildMiddlePageValue(index + 1), list || []);
    });
  }

  relabelFormPages() {
    const formPages = (this.pageSettings || []).filter((item: any) => item.value === 'start' || isMiddlePage(item.value));
    formPages.forEach((item: any, index: number) => {
      item.value = index === 0 ? 'start' : `middle${index === 1 ? '' : index}`;
      item.label = formPages.length > 1 ? `表单步骤${index + 1}` : '表单';
      item.deletable = formPages.length > 1;
    });
  }

  syncEndPageOpacity() {
    const endPage = this.pageSettings.find((item: any) => item.value === 'end');
    if (!endPage || !this.formData?.settings?.rules) {
      return;
    }

    const hasMiddlePage = getMiddlePageValues(this.pageSettings || []).length > 0;
    endPage.opacity = hasMiddlePage
      ? (this.formData.settings.rules.middleButtonAction === 'open' ? 1 : 0)
      : (this.formData.settings.rules.buttonAction === 'open' ? 1 : 0);
  }

  private buildMiddleScopedPrefixRegex(pageValue: string, includeStyleSeparator = false): RegExp {
    const prefix = includeStyleSeparator ? `__${pageValue}` : pageValue;
    // 避免 middle3 误匹配 middle30，要求前缀后不是数字
    return new RegExp(`^${prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?!\\d)`);
  }

  private replaceMiddleScopedPrefix(key: string, fromPage: string, toPage: string, includeStyleSeparator = false): string {
    const fromRegex = this.buildMiddleScopedPrefixRegex(fromPage, includeStyleSeparator);
    const toPrefix = includeStyleSeparator ? `__${toPage}` : toPage;
    return key.replace(fromRegex, toPrefix);
  }

  private copyMiddleScopedObjectFields(container: any, fromPage: string, toPage: string) {
    if (!container || fromPage === toPage) return;
    const fromRegex = this.buildMiddleScopedPrefixRegex(fromPage);
    Object.keys(container)
      .filter((key: string) => fromRegex.test(key))
      .forEach((sourceKey: string) => {
        const targetKey = this.replaceMiddleScopedPrefix(sourceKey, fromPage, toPage);
        const value = container[sourceKey];
        Vue.set(container, targetKey, value && typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value);
      });
  }

  private copyMiddleScopedStyleMap(fromPage: string, toPage: string) {
    const styleMap = (this.formData?.settings as any)?.styles?.styleMap;
    if (!styleMap || fromPage === toPage) return;
    const fromScopedSegment = `__${fromPage}`;
    const fromRegex = new RegExp(`${fromScopedSegment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?!\\d)`, 'g');
    Object.keys(styleMap)
      .filter((key: string) => new RegExp(`${fromScopedSegment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(?!\\d)`).test(key))
      .forEach((sourceKey: string) => {
        const targetKey = sourceKey.replace(fromRegex, `__${toPage}`);
        const value = styleMap[sourceKey];
        Vue.set(styleMap, targetKey, value && typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value);
      });
  }

  private copyMiddleScopedConfig(fromPage: string, toPage: string) {
    const settings: any = this.formData?.settings;
    if (!settings || fromPage === toPage) return;
    this.copyMiddleScopedObjectFields(settings.rules, fromPage, toPage);
    this.copyMiddleScopedObjectFields(settings.texts, fromPage, toPage);
    this.copyMiddleScopedObjectFields(settings.typesetting, fromPage, toPage);
    this.copyMiddleScopedObjectFields(settings.logo, fromPage, toPage);
    this.copyMiddleScopedStyleMap(fromPage, toPage);
  }

  /** 确认删除页面 */
  confirmDeletePage() {
    if (!this.deletePageValue || !this.pageSettings || !Array.isArray(this.pageSettings)) {
      this.showDeletePageDialog = false;
      return;
    }

    if (this.deletePageValue === 'cover') {
      this.pageSettings.splice(0, 1);
      delete this.formData.settings.cover;
      this.$emit('changeActivePageSetting', this.pageSettings[0].value);
      this.showDeletePageDialog = false;
      this.deletePageValue = null;
      return;
    }

    const index = this.pageSettings.findIndex((item: any) => item.value === this.deletePageValue);
    if (index > -1) {
      console.log('confirmDeletePage', this.deletePageValue,  this.activePageSetting, this.pageSettings, this.pageSettings[index]);
      const formPages = getFormPageValues(this.pageSettings || []);
      if (formPages.includes(this.deletePageValue)) {
        const remainingFormPages = formPages.filter((value: string) => value !== this.deletePageValue);
        const remainingFormPageArrays = this.getFormPageArrays(remainingFormPages);

        if (this.deletePageValue === 'start' && remainingFormPages.length > 0 && this.formData?.settings) {
          copyMiddleToStart(this.formData.settings);
        }

        this.rebuildFormPageSettings(remainingFormPageArrays);
        this.pageSettings.splice(index, 1);
        this.relabelFormPages();

        if (this.formData?.settings?.rules) {
          Vue.set(this.formData.settings.rules, 'stepDisplay', getMiddlePageValues(this.pageSettings || []).length > 0);
          if (getMiddlePageValues(this.pageSettings || []).length === 0) {
            Vue.delete(this.formData.settings.rules, 'middleButtonAction');
          }
        }

        this.syncEndPageOpacity();
      } else {
        this.pageSettings.splice(index, 1);
      }

      // 如果要删除的是当前激活的页面，需要切换到其他页面
      if (this.activePageSetting === this.deletePageValue) {
        // 如果删除的是第一个，切换到下一个；否则切换到前一个
        if (index === 0 && this.pageSettings.length > 1) {
          this.$emit('changeActivePageSetting', this.pageSettings[0].value);
        } else if (index > 0) {
          this.$emit('changeActivePageSetting', this.pageSettings[Math.min(index - 1, this.pageSettings.length - 1)].value);
        }
      }
    }

    this.showDeletePageDialog = false;
    this.deletePageValue = null;
  }

  /** 增加表单页面 */
  handleAddForm() {
    if (!this.pageSettings || !Array.isArray(this.pageSettings)) return;
    const newFormValue = getNextAvailableMiddlePageValue(this.pageSettings || []);
    if (!newFormValue) {
      return;
    }

    // 开始按钮行为打开下一步骤
    this.formData.settings.rules.buttonAction = 'open';
    this.formData.settings.rules.openUrl = '';

    const formPages = getFormPageValues(this.pageSettings || []);
    const hasMiddlePage = getMiddlePageValues(this.pageSettings || []).length > 0;

    // 复制开始页的配置到步骤页，后续新增步骤复制已有中间页的表单字段
    if (this.formData && this.formData.settings) {
      if (!hasMiddlePage) {
        copyStartToMiddle(this.formData.settings);
      } else {
        // 从上一步复制 scoped 配置（样式/规则/文案/排版），保证新步骤默认继承上一步
        const existingMiddlePages = getMiddlePageValues(this.pageSettings || []);
        const lastMiddlePage = existingMiddlePages[existingMiddlePages.length - 1] || 'middle';
        this.copyMiddleScopedConfig(lastMiddlePage, newFormValue);
      }
      // 默认采集项只放手机号
      const mobileNumberItem = shortFormAddList.find(item => item.type === 'Mobile Number');
      if (mobileNumberItem) {
        Vue.set((this.formData.settings as any), newFormValue, [JSON.parse(JSON.stringify(mobileNumberItem))]);
      }
    }

    const newFormPage = {
      value: newFormValue,
      label: `表单步骤${formPages.length + 1}`,
      deletable: true,
      opacity: 1
    };

    const lastFormPageValue = formPages[formPages.length - 1] || 'start';
    const insertIndex = this.pageSettings.findIndex((item: any) => item.value === lastFormPageValue);
    this.pageSettings.splice(insertIndex + 1, 0, newFormPage);
    this.relabelFormPages();
    Vue.set(this.formData.settings.rules, 'stepDisplay', true);
    this.syncEndPageOpacity();

    (window as any)?.gtagClick?.('modal_edit_addStepForm', '弹窗_编辑订阅工具_添加步骤_表单');
    // 切换到新表单页面
    this.$emit('changeActivePageSetting', newFormValue);
  }

  /** 增加封面页面 */
  handleAddCover() {
    if (!this.pageSettings || !Array.isArray(this.pageSettings)) return;

    // 检查是否已存在封面
    const hasCover = this.pageSettings.some((item: any) => item.value === 'cover');
    if (hasCover) {
      return;
    }

    // 创建封面对象
    const coverPage = {
      value: 'cover',
      label: '封面',
      deletable: true,
      opacity: 1,
      ...(this.enableCustomStep ? { deletable: true } : {})
    };

    // 将封面插入到数组最前面
    this.pageSettings.unshift(coverPage);

    // 使用表单的背景颜色和关闭按钮颜色
    this.formData.settings.cover = {
      coverJumpType: 'click',
      bgCoverImgUrl: undefined,
      closeColor: this.formData.settings.rules.closeColor as string,
    };

    this.formData.settings.styles.styleMap['cartx-b-show__cover'].background = this.formData.settings.styles.styleMap['cartx-b-show'].background as string;

    // 强制更新以触发计算属性重新计算
    // this.$forceUpdate();

    // 切换到封面页面
    this.$emit('changeActivePageSetting', 'cover');
  }
}
